<template>
  <div class="page contatti">
    <b-container class="contatti__container">
      <section class="section contatti__header">
        <p class="contatti__eyebrow">Contatti</p>
        <h1 class="contatti__title">Scrivici</h1>
        <p class="contatti__text">
          <strong>Il form online è il canale più veloce</strong> per richiedere informazioni, modifiche, rimborsi o servizi extra. Compila il form e riceverai risposta da un nostro operatore.<br />
          In caso di emergenza in aeroporto o problemi d’imbarco fuori orario, rivolgiti al desk della compagnia aerea e inviaci una segnalazione tramite il form.
        </p>

        <form-richiesta-assistenza
          :request_types="request_types"
          :confirmcode="confirmcode"
          :email="email"
        />
      </section>

      <section class="section contatti__channels">
        <p class="contatti__text">
          Per partenze entro 48 ore, contattaci telefonicamente dal <strong>lunedì al venerdì, dalle 9:00 alle 18:00</strong>.<br />
          In caso di emergenza in aeroporto o problemi d’imbarco fuori orario, rivolgiti al desk della compagnia aerea e segnala comunque la richiesta tramite il form.
        </p>

        <div v-if="channels.length" class="contatti__cards">
          <template v-for="channel in channels">
            <customer-support-action
              v-if="channel.chat"
              :key="channel.id"
              cta_id="contatti-webchat"
              class="contatti__card"
            >
              <feature-card v-bind="channel.card" />
            </customer-support-action>

            <a
              v-else
              :key="channel.id"
              :href="channel.href"
              :target="channel.target"
              :rel="channel.target ? 'noopener' : null"
              class="contatti__card"
            >
              <feature-card v-bind="channel.card" />
            </a>
          </template>
        </div>
      </section>
    </b-container>
  </div>
</template>

<script>
import * as site_resources from '@running_app_src/resources'
import FormRichiestaAssistenza from '@components/blocks/form-richiesta-assistenza.vue'
import FeatureCard from '@components/blocks/feature-card.vue'

export default {
  name: 'contatti',
  metaInfo: {
    title: 'Contatti',
  },
  components: {
    'form-richiesta-assistenza': FormRichiestaAssistenza,
    'feature-card': FeatureCard,
  },
  props: {
    confirmcode: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      request_types: site_resources.support_request_types || [],
    }
  },
  computed: {
    channels() {
      const phone = this.get_config('site.phoneNumber', '')
      const mobile = this.get_config('site.mobileNumber', '')
      const wa_link = this.get_config('site.waIntentLink', '')

      return [
        phone && {
          id: 'phone',
          href: `tel:${phone.replace(/\s+/g, '')}`,
          card: { icon: 'phone', title: 'Telefono', text: phone, caption: 'Lun – Ven, 9:00 – 18:00', title_size: 18 },
        },
        mobile && wa_link && {
          id: 'whatsapp',
          href: wa_link,
          target: '_blank',
          card: { icon: 'whatsapp', title: 'Whatsapp', text: mobile, title_size: 18 },
        },
        {
          id: 'webchat',
          chat: true,
          card: { icon: 'chat', title: 'WebChat', text: 'Ottieni risposte e in tempo reale', title_size: 18 },
        },
      ].filter(Boolean)
    },
  },
}
</script>

<style lang="scss" scoped>
.contatti {

  &__container {
    @extend %support-page-container;
  }

  &__header {
    margin-bottom: 0;
  }

  &__eyebrow {
    @extend %support-page-header__eyebrow;
  }

  &__title {
    @extend %support-page-header__title;
  }

  &__text {
    margin-bottom: $grid-gutter-20;
    font-size: $font-size-base;
    color: $gray-900;
  }

  &__channels {
    padding-top: $grid-gutter-width;
    margin-top: $grid-gutter-20;
    border-top: 1px solid $gray-300;
  }

  &__cards {
    display: grid;
    grid-template-columns: 1fr;
    gap: $grid-gutter-20;

    @include media-breakpoint-up(md) {
      grid-template-columns: repeat(3, 1fr);
    }

    @include media-breakpoint-up(lg) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  &__card {
    display: block;
    color: inherit;
    text-decoration: none;
    border-radius: $border-radius-lg * 2;
    transition: box-shadow .2s ease;

    &:hover,
    &:focus {
      color: inherit;
      box-shadow: $box-shadow-sm;
    }
  }

  &__card ::v-deep .feature-card {

    &__icon {
      padding: 0;
      margin-bottom: $grid-gutter-width / 4;

      svg {
        width: 32px;
        height: 32px;
      }
    }

    &__text {
      margin-bottom: $grid-gutter-width / 6;
    }
  }
}
</style>

<style lang="scss">
.site-main:has(.contatti__container) ~ .site-prefooter {
  display: none;
}
</style>
